import s from "../utils.js";
import f from "./toFormData.js";
import r from "../platform/index.js";
function d(o, i) {
  return f(o, new r.classes.URLSearchParams(), {
    visitor: function(t, a, n, e) {
      return r.isNode && s.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : e.defaultVisitor.apply(this, arguments);
    },
    ...i
  });
}
export {
  d as default
};
